import { fetchCommercialBreadcrumbs } from './fetchCommercialBreadcrumbs';
import { IFetchCommercialBreadcrumbsParameters } from './types';
import { ICommercialBreadcrumbs } from '../../types/commercialBreadcrumbs';
import { IApplicationContext } from '../../types/applicationContext';

export async function fetchCommercialBreadcrumbsSafe(
  context: IApplicationContext,
  parameters: IFetchCommercialBreadcrumbsParameters,
): Promise<ICommercialBreadcrumbs | null> {
  try {
    return await fetchCommercialBreadcrumbs(context, parameters);
  } catch (ex) {
    const { logger } = context;

    logger.warning(ex, {
      degradation: 'Хлебные крошки коммерческой',
    });

    return null;
  }
}
